<template>
  <j-modal :title="title" :width="1200" :visible="visible" :confirmLoading="confirmLoading" :maskClosable="false"
    :body-style="{ height: '580px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk" @cancel="handleCancel"
    :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <div>
        <div style="display: flex;justify-content: space-between;">
          <div style="width: 48%;">
            <a-divider orientation="left">{{ $t('读取身份证信息') }}</a-divider>
            <div style="display: flex;border: 1px solid #eee;padding: 10px;height: 400px;">
              <div style="flex: 1;">
                <detail-list :col="1">
                  <detail-list-item :term="$t('证件姓名')">{{userInfo.name}}</detail-list-item>
                  <!-- <detail-list-item term="证件类型">{{userInfo.type}}</detail-list-item> -->
                  <detail-list-item :term="$t('证件号码')">{{userInfo.number}}</detail-list-item>
                  <detail-list-item :term="$t('地址')">{{userInfo.address}}</detail-list-item>
                  <detail-list-item :term="$t('性别')" :itemCol="1">{{userInfo.sex}}</detail-list-item>
                  <detail-list-item :term="$t('名族')" :itemCol="1">{{userInfo.nation}}</detail-list-item>
                  <detail-list-item :term="$t('出生日期')" :itemCol="1">{{userInfo.birth}}</detail-list-item>
                  <detail-list-item :term="$t('签发机关')" :itemCol="1">{{userInfo.organization}}</detail-list-item>
                  <detail-list-item :term="$t('有效期起始')">{{userInfo.dateStart}}</detail-list-item>
                  <detail-list-item :term="$t('有效期终止')">{{userInfo.dateEnd}}</detail-list-item>
                </detail-list>
              </div>
              <div style="width: 150px;height: 200px;border:1px solid #eee;display: flex;align-items: center;justify-content: center;">
                <img :src="headImg" alt="" style="width: 100%;height: 100%;" v-if="headImg" />
                <div v-else><em>{{ $t('暂无头像') }}</em></div>
              </div>
            </div>
            <div style="display: flex;justify-content: space-evenly;margin-top: 30px;">
              <a-button type="primary" @click="readIDCard">
                  {{ $t('读身份证') }}
              </a-button>
              <a-button type="default" @click="faceIdentify">
                  {{ $t('人脸核验') }}
              </a-button>
            </div>
          </div>
          <div style="width: 48%;">
            <a-divider orientation="left">{{ $t('人像采集') }}</a-divider>
            <div style="border: 1px solid #eee;padding: 10px;height: 400px;">
              <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
                <img :src="faceImg" alt="" style="width: 100%;height: 100%;" v-if="faceImg" />
                <div v-else><em>{{ $t('摄像头暂未开启') }}</em></div>
              </div>
            </div>
            <div style="display: flex;margin-top: 20px;border: 1px solid #1890FF;">
              <div style="height: 70px;width: 70px;background-color: #1890FF;color: #fff;display: flex;justify-content: center;align-items: center;">{{ $t('比对') }}<br/>{{ $t('结果') }}</div>
              <div style="color: #333;line-height: 70px;font-size: 20px;flex: 1;text-align: center;">{{faceText}}</div>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import Vue from 'vue'
  export default {
    name: 'readIDCardModal',
    components: {
      DetailList,
      DetailListItem,
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        userInfo: {},
        headImg: '',
        faceImg: '',
        faceText: ''
      }
    },
    methods: {
      init(row) {
        this.title = this.$t('人脸核验');
        this.visible = true;
        this.userInfo = {};
        this.headImg = '';
        this.faceImg = '';
        this.faceText = '';
        this.initWebSocket();
      },
      handleOk() {
        if(this.userInfo.similarity){
          this.$emit('ok', true);
        }else{
          this.$emit('ok', false);
        }
        this.close();
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      readIDCard(){
        this.$message.success(this.$t('读取身份证信息中，请稍等！'))
        let json = {"Type":"4","Method":"star_ReadIdInfo","nPort":"0","nBaud":"9600","cBp":"0","szBmpPath":"D:\\test.bmp","nTimeout":"10","szVoice":"请放置身份证"};//二代身份证
        this.websocketSend(JSON.stringify(json));
      },
      faceIdentify(){
        // if(!this.userInfo.name){
        //   this.$message.warning('请将身份证放置在仪器上识别！');
        // }else{
          this.$message.success(this.$t('请正对摄像头，正在开启人脸识别。请稍等！'));
          var json = {"Type":"4","Method":"star_ReadIdInfo","nPort":"0","nBaud":"9600","cBp":"0","szBmpPath":"D:\\test.bmp","nTimeout":"10","szVoice":"请放置身份证"};//二代身份证
          this.websocketSend(JSON.stringify(json));
          setTimeout(()=>{
            var json1 = {"Type":"1","Method":"star_OpenCam","nIndex":"1","szRes":"640x480"};
            this.websocketSend(JSON.stringify(json1));
          },3000)
          setTimeout(()=>{
            var json2 = {"Type":"1","Method":"star_Capture","szPhotoPath":"D:\\face1.jpg","nIndex":"1","szVoice":"请看摄像头"};
            this.websocketSend(JSON.stringify(json2));
          },6000)
          setTimeout(()=>{
            var json3 = {"Type":"1","Method":"star_CloseCam","nIndex":"1"};
            this.websocketSend(JSON.stringify(json3));
          },9000)
          setTimeout(()=>{
            var json5 = {"Type":"5","Method":"star_GetFaceDetectResult","nPort":"0","nBaud":"9600","cBp":"0","nActionType":"1","szPicPath1":"D:\\face1.jpg","szPicPath2":"D:\\test.bmp","nVoiceType":"2","szVoice":"人脸识别中","nTimeout":"60"}
            this.websocketSend(JSON.stringify(json5));
          },11000)
        // }
      },
      // websocket消息通知开始
      initWebSocket() {
        // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
        var userId = this.$store.getters.userInfo.id;
        // var url = window._CONFIG['domianURL'].replace("https://", "wss://").replace("http://", "ws://") + "/websocket/" + userId;
        // var url = 'ws://localhost:19998/'
        // var url = 'http://172.16.8.137:19998/'
        var url = 'http://127.0.0.1:19998/'

        //update-begin-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
        let token = Vue.ls.get('ACCESS_TOKEN')

        this.websocket = new WebSocket(url);
        //update-end-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
        this.websocket.onopen = this.websocketOnopen;
        this.websocket.onerror = this.websocketOnerror;
        this.websocket.onmessage = this.websocketOnmessage;
        this.websocket.onclose = this.websocketOnclose;
      },
      websocketOnopen() {
        console.log("WebSocket消息通知layout连接成功");
        //心跳检测重置
        // this.heartCheck.reset().start();
      },
      websocketOnerror(e) {
        console.log("WebSocket连接发生错误，第%s次", this.wsConnectErrorTime);

        this.wsConnectErrorTime = this.wsConnectErrorTime + 1;
        if (this.wsConnectErrorTime > 5) {
          console.log("WebSocket连接错误超过5次，就不再重新连了！");
          this.lockReconnect = true
          return;
        }
        // this.reconnect();
      },
      websocketOnmessage(e) {
        let data = JSON.parse(e.data); //解析json字符串
        console.log("WebSocket消息通知layout收到消息", data);
        // 按照实际需求处理消息（即只推送给含有特定消息类型的用户）
        // if(this.messageType.findIndex(item => item == data.port) == -1) {
        //   return
        // }
        console.log(data);
        if (data.Type == 4 && data.Method == "star_ReadIdInfo") { // 身份证识别结果
          if(data.ret == 0){
            // 二代身份证
            var szIdInfo = data.szIdInfo;
            var infoList = szIdInfo.split('|');
            this.userInfo = {
              name: infoList[0],
              type: infoList[9],
              number: infoList[5],
              address: infoList[4],
              sex: infoList[1],
              nation: infoList[2],
              organization: infoList[6],
              birth: infoList[3],
              dateStart: infoList[7],
              dateEnd: infoList[8],
            }
            this.headImg = "data:image/png; base64," + data.szPhotoBase64;
          }else{
            this.$message.warning(this.$t('请将身份证放置在仪器上识别！'))
          }
        }else if(data.Type == 5 && data.Method == 'star_GetFaceDetectResult'){// 人脸核验结果
          var ret = data.ret;
          var nResult = data.nResult;
          if(ret == 0){
            this.$set(this.userInfo,'similarity',nResult);
            this.faceText = this.$t('相似度{nResult}%', { nResult: nResult });
          }else{
            this.$message.warning(this.$t('识别错误！'));
          }
        }else if(data.Type == 1 && data.Method == "star_Preview"){// 预览结果
          if(data.ret == 0){
            this.faceImg = "data:image/png; base64,"+data.szPhotoBase64;
          }
        }else if(data.Type == 1 && data.Method == "star_Capture" && data.nIndex == 1){// 客户头拍照结果
          if(data.ret == 0){
            this.faceImg = "data:image/png; base64,"+data.szPhotoBase64;
          }
        }
      },
      websocketOnclose(e) {
        console.log("connection closed (" + e + ")");
        if (e) {
          console.log("connection closed (" + e.code + ")");
        }
        // this.reconnect();
      },
      websocketSend(text) { // 数据发送
        try {
          this.websocket.send(text);
        } catch (err) {
          console.log("send failed (" + err.code + ")");
        }
      },
    }
  }
</script>
<style scoped>
  /deep/.detail-list .content {
    line-height: normal;
  }
</style>